<template>
<div class="two-tables mt-5">
    <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
        <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
    </div>
    <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>

    <h3 v-if="tableData.table_name" class="table-title text-uppercase mb-4 mt-4 mt-lg-0">{{ tableData.table_name }}</h3>

    <div
        class="table-wrap flex-grow-1 p-3 right no-compare two-metrics"
        :class="{
            'with-definitions': show_definitions
        }">
    >
        <v-client-table :data="tblData" :columns="columns" :options="options">
            <template v-for="(column, idx) in columns" :slot="column" slot-scope="props">
                <template v-if="show_arrow || show_percent_change">
                    <div v-if="column.includes('seg')" :title="props.row[column]['title']">
                        {{props.row[column]['value']}}
                        <div v-if="show_definitions" class="definitions">
                            {{ definitions[props.row[column]['title']] }}
                        </div>
                    </div>
                    <template v-else>
                        <template v-if="props.row[column]['sign'] == 'empty'">
                            <span v-if="!!props.row[column]" class="value-with-additionals" :class="'column-'+idx">
                                {{props.row[column]['value']}}
                            </span>
                            <span v-if="!!props.row[column]" class="arrow-wrap" :class="'column-'+idx"><span class="arrow" :class="props.row[column]['sign']"></span>{{props.row[column]['perc']}}</span>
                        </template>
                        <template v-else>
                            <span v-if="!!props.row[column]" class="value-with-additionals" :class="'column-'+idx">
                                {{props.row[column]['value']}}
                            </span>
                            <template v-if="show_percent_change">
                                <span v-if="!!props.row[column] && props.row[column]['sign']=='na'" class="arrow-wrap" :class="'column-'+idx"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                <span v-if="!!props.row[column] && props.row[column]['sign']!='na'" class="arrow-wrap" :class="'column-'+idx"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                            </template>
                            <template v-else>
                                <span v-if="!!props.row[column]" class="arrow-wrap" :class="'column-'+idx"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span></span>
                            </template>
                        </template>
                    </template>
                </template>
                <template v-else>
                    <span v-if="column.includes('seg')" :title="props.row[column]['title']">
                        {{props.row[column]['value']}}
                        <div v-if="show_definitions" class="definitions">
                            {{ definitions[props.row[column]['title']] }}
                        </div>
                    </span>
                    <span v-else :class="props.row">
                        {{props.row[column]['value']}}
                    </span>
                </template>
            </template>
        </v-client-table>
        <!-- <div>
            <ul>
                <li v-for="(definition, key) in definitions" class="definitions">
                    <span class="definitions def2 key">{{key}}</span><p><span class="definitions def2 val">{{definition}}</span></p>
                </li>
            </ul>
        </div> -->
    </div>
</div>
</template>

<script>
    export default {
        props: ['hasSkb', 'tableData'],
        created() {
            this.tableData.element_abbreviation = 'single_table_grouping_blue';

            this.show_arrow = this.tableData.element_configurations.show_arrows;
            this.show_percent_change = this.tableData.element_configurations.show_percent_change;
            this.show_definitions = !!this.tableData.reporting_table_type_configurations && !!this.tableData.reporting_table_type_configurations.show_definitions ? this.tableData.reporting_table_type_configurations.show_definitions : null;
            this.hide_total_row = this.tableData.element_configurations.hide_total_row;

            this.fetchServerData();
            event_bus.$on('current_dwm', () => {
                this.current_dwm = this.$store.state.current_dwm;
                event_bus.$emit('reloading', true);
            });
        },
        data() {
            return {
                isArchive:this.$store.state.isArchive,
                descr:{},
                columns:[],
                options:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    perPage: 25,
                    perPageValues:[25,50,100,1000],
                    skin: 'table'
                },
                definitions:[],
                tblData:[],
                query:'',
                showQueries: this.$store.state.showQueries,
                reloading:true,
                show_arrow: false,
                show_percent_change: false,
                hide_total_row:false,
            }
        },
        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.isArchive ? this.tableData.archive_id : this.tableData.report_id,
                    'element_abbr':this.tableData.element_abbreviation,
                    'show_as_triple':false,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.tableData.element_id,
                    'prefixed_element_id': this.tableData.report_element_id,
                    'metrics': this.tableData.metrics,
                    'segment': this.tableData.segment,
                    'accounts': this.tableData.accounts,
                    'client_id': this.tableData.client_id,
                    'rules': this.tableData.rules,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                    'show_arrow':this.show_arrow,
                    'show_percent_change':this.show_percent_change,
                    'hide_total_row':this.hide_total_row,
                };

                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        let data = response.data;

                        this.tblData = data.tblData
                        this.columns = data.columns
                        this.options.headings = data.headings
                        this.definitions = data.definitions || []
                        this.query = data.query;
                    }
                    this.reloading = false;
                });
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.single-table{
        .table {
            thead th{
                border-bottom:none !important;
                color:$light-blue;
                padding-bottom:2rem !important;
            }
            tbody tr {
                color:$black-blue;
                font-weight:500;
                line-height:1.5;
                &:nth-child(odd){
                    background-color:$strip-gray4;
                }
            }
        }
    }

    div.with-definitions {
        td {
            white-space: normal !important;

            .definitions {
                font-size: 1.2rem !important;
            }
        }
    }
</style>
